export default {
    date: null,
    courses: [],
};



// WEBPACK FOOTER //
// ./src/store/calendar/state.js